import React, {forwardRef, useImperativeHandle, useState} from 'react';
import {Button, Modal} from "react-bootstrap";
import Loading from "../../components/loading";
import {Form, Formik} from "formik";
import {bankAccountRequestSchema} from "../../utils/schemas";
import FormGroup from "../../components/form-group";
import HelperService from "../../services/helper-service";
import Section from "../../components/section";
import {useGlobalNotificationMessage} from "../../context/message";
import {useBankAccountService} from "../../services/bank-account-service";

const AddEditBankAccountModal = forwardRef( ({onSuccess=null, ...props}, ref) => {
  const [show, setShow] = useState(false);
  const [model, setModel] = useState();
  const [loading, setLoading] = useState(false);
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
  const [reset, setReset] = useState(0);

  let formSchema = bankAccountRequestSchema;

  let bankAccountService = useBankAccountService();

  //expose api for interacting with component
  useImperativeHandle(ref, () => ({
    openModal: openModal,
    closeModal: closeModal,
  }));

  const openModal = (model=null, userId) => {
    setLoading(true);
    if (!userId){
      throw new Error('No user info');
    }

    let promises = [
      Promise.resolve({user_id: userId})
    ];

    if (model && model.id){
      promises.push(getDetail(model.id));
    }

    Promise.all(promises).then(([userId={}, detail= {}])=>{
      let newDetail = Object.assign({}, userId, detail);
      setModel(formSchema.cast(newDetail));
      setLoading(false);
    });

    setShow(true);
  }
  const closeModal = () => {
    setShow(false);
    setReset(reset+1);
    setModel(formSchema.cast());
  }

  const getDetail = (id) => {
    return bankAccountService.getDetail(id);
  }

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    removeMessage();
    let reqValues = {...values};

    bankAccountService.addEditModel(reqValues, reqValues.id)
      .then((res) => {
        if (onSuccess && 'function' === typeof onSuccess){
          onSuccess(res);
        }
        closeModal();
      })
      .catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa uložiť zmeny.");
        HelperService.handleFormErrors(error, setErrors);
      })
      .finally(()=>{ setSubmitting(false);});
  };

  return (
    <>
      <Formik
        key={reset}
        enableReinitialize={true}
        initialValues={formSchema.cast(model) || formSchema.cast()}
        validationSchema={formSchema}
        onSubmit={onSubmit}
      >
        {({ isSubmitting, errors, touched, handleSubmit, setFieldValue}) => (

          <Modal size="lg" show={!!show} onHide={closeModal} centered>
            <Modal.Header closeButton>
              { model && <Modal.Title>{ !model.id ? 'Nový bankový účet' : 'Úprava bankového účtu' }</Modal.Title>}
            </Modal.Header>
            <Modal.Body>
              <Section animation={HelperService.getRandomAnimation()}>

                {loading && <Loading className="m-2" />}

                {!loading && <Form className="row">

                  <FormGroup
                    name="IBAN"
                    placeholder="IBAN"
                    label="IBAN"
                    className="col-md-4"
                    touched={touched} errors={errors} schema={formSchema}
                  />

                  <FormGroup
                    name="SWIFT"
                    placeholder="SWIFT"
                    label="SWIFT"
                    className="col-md-4"
                    touched={touched} errors={errors} schema={formSchema}
                  />

                  <FormGroup
                    name="bank"
                    placeholder="Banka"
                    label="Banka"
                    className="col-md-4"
                    touched={touched} errors={errors} schema={formSchema}
                  />

                  <FormGroup
                    name="title"
                    placeholder={'Názov'}
                    label="Názov"
                    className="col-md-4"
                    touched={touched} errors={errors} schema={formSchema}
                  />

                  <div className="clearfix"></div>

                </Form>}

              </Section>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="outline-secondary" onClick={closeModal}>Zatvoriť</Button>
              <Button type="submit" variant="primary" onClick={handleSubmit} disabled={isSubmitting}>Odoslať</Button>
            </Modal.Footer>
          </Modal>
        )}
      </Formik>

    </>
  );
});

export default AddEditBankAccountModal;
